<template>
  <div>
    <select class="form-select" :value="selectedValue" @change="submitChange($event)">
      <option v-for="(label, value) in options" :key="value" :value="value">{{ label }}</option>
    </select>
  </div>
</template>

<script lang="ts">
import naja from 'naja';
import {defineComponent, PropType, ref} from 'vue';

export default defineComponent({
    props: {
        changeUrl: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: true,
        },
        options: {
            type: Object as PropType<Record<string, string>>,
            required: true,
        },
    },
    setup(props) {
        const selectedValue = ref(props.value);

        function submitChange(event: Event): void {
            const target = event.target as HTMLSelectElement;
            selectedValue.value = target.value;

            naja.makeRequest('POST', props.changeUrl, {value: target.value});
        }

        return {selectedValue, submitChange};
    },
});
</script>
